module.exports = __webpack_public_path__ + "phoneIco.png?b19f830f73fc15b455e32cb765f1be4c";